export default {
  LOAD_DEPARTMENT_FORM_PAGE_START: 'LoadDepartmentFormPageStart',
  LOAD_DEPARTMENT_FORM_PAGE_END: 'LoadDepartmentFormPageEnd',
  CLEAR_DEPARTMENT_FORM_PAGE: 'ClearDepartmentFormPage'
};